import { BlogShowcase } from '../components/blog/BlogShowcase';
import { usePageSeo } from '../hooks/usePageSeo';
import { blogIndexJsonLd, PAGE_SEO } from '../lib/seo';
import '../styles/blog-page.css';

export function BlogPage() {
  usePageSeo({
    ...PAGE_SEO.blog,
    jsonLd: blogIndexJsonLd(),
  });

  return <BlogShowcase />;
}
